export default __webpack_public_path__ + "static/media/python.73887503.png";